import { useQuery } from '@tanstack/react-query';
import type { ApiResponse } from '../../@types/ApiResponse';
import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import { getJSON } from '../../fetch';
import useAuth from '../../hooks/useAuth';

export interface AdminBranchSearch {
  id: string;
  marketCode: 'SE' | 'NO';
  parentId: string;
  isParent: boolean;
  isCentralStorage: boolean;
  name: string;
  description: string;
  telephone: string;
  email: string;
  street: string;
  zip: string;
  city: string;
  county: string;
  longitude: number;
  latitude: number;
  organizationNumber: string;
  resellerFor: string[];
  useTransparentLogo: boolean;
  hideDirectMessagingOnLandingPage: boolean;
  acceptsAssignments: boolean;
  wxrExtendedBoostEnabled: boolean;
}

export const ADMIN_BRANCHES_SEARCH_QUERY = '/api/organisation/branches/admin/search';

const useSearchBranchesAdmin = (
  query: string,
): [AdminBranchSearch[] | undefined, RequestStateQuery] => {
  const { getToken } = useAuth();

  const { data, isLoading, isSuccess, isError, isFetching } = useQuery<
    ApiResponse<AdminBranchSearch[]>
  >({
    queryKey: [ADMIN_BRANCHES_SEARCH_QUERY, query],
    queryFn: async () => {
      return await getJSON<ApiResponse<AdminBranchSearch[]>>(
        `/api/organisation/branches/admin/search?q=${query}`,
        getToken()!,
      );
    },
    enabled: !!query,
  });
  return [data?.response, { isLoading, isSuccess, isError, isFetching }];
};

export default useSearchBranchesAdmin;
